// extracted by mini-css-extract-plugin
export default {"input":"Input_input__uXeNq","professions":"Input_professions__NzmRC","inputProf":"Input_inputProf__9fB3C"};